import React, { useState } from "react";
import { PlusCircle, Filter, Search, RefreshCw, BanknoteIcon, MedalIcon } from "lucide-react";
import QuotaList from "../../component/QuotaList";
import CourseList from "../../component/CourseList";
import QuizList from "./QuizeList";
import CreateQuizModal from "./models/createQuize";

const QuizManagement = () => {
  const [courseId, setCourseId] = useState("");
  const [quotaId, setQuotaId] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [quotas, setQuotas] = useState([]);
  const [showUpdateModal, setShowUpdateModal] = useState(false);
  const [selectedQuiz, setSelectedQuiz] = useState(null);
  const [isRefreshing, setIsRefreshing] = useState(false);
  const [refreshFlag, setRefreshFlag] = useState(false);

  const handleOpenModal = () => setShowModal(true);
  const handleCloseModal = () => setShowModal(false);

  const handleQuizCreated = (newQuiz) => {
    console.log("New quiz created:", newQuiz);
    refreshQuizList();
  };

  const handleOpenUpdateModal = (quiz) => {
    setSelectedQuiz(quiz);
    setShowUpdateModal(true);
  };

  const handleCloseUpdateModal = () => {
    setSelectedQuiz(null);
    setShowUpdateModal(false);
  };

  const handleQuizUpdated = (updatedQuiz) => {
    console.log("Quiz updated:", updatedQuiz);
    refreshQuizList();
  };

  const refreshQuizList = () => {
    setIsRefreshing(true);
    // Simulate refresh with timeout
    setTimeout(() => {
      setIsRefreshing(false);
    }, 800);
  };

  return (
    <div className="flex flex-col h-full bg-gray-50 dark:bg-gray-900">
      {/* Header */}
      <div className="border-b border-gray-200 dark:border-gray-800 bg-white dark:bg-gray-950 px-4 md:px-6 py-4">
        <div className="flex flex-col md:flex-row items-start gap-6  md:items-center justify-between mb-6 md:mb-8 mt-6 md:mt-0">
          <div className="mb-">
            <h1 className="text-2xl md:text-3xl font-bold text-gray-900 flex flex-row items-center gap-2">
              <MedalIcon className="size-7" /> Quize Management
            </h1>
            <p className="text-gray-600 mt-1">
              Manage your quizzes and assessments efficiently.
            </p>
          </div>
          <div className="flex items-center space-x-2">
            <button
              onClick={refreshQuizList}
              className="p-2 text-gray-500 hover:text-gray-700 dark:text-gray-400 dark:hover:text-gray-200 rounded-full hover:bg-gray-100 dark:hover:bg-gray-800 transition-colors"
            >
              <RefreshCw
                size={18}
                className={isRefreshing ? "animate-spin" : ""}
              />
            </button>
            <button
              onClick={handleOpenModal}
              disabled={!quotaId}
              className="flex items-center space-x-2 px-4 py-2 bg-blue-600 hover:bg-blue-700 text-white rounded-md disabled:bg-gray-300 disabled:cursor-not-allowed dark:disabled:bg-gray-700 transition-colors"
            >
              <PlusCircle size={16} />
              <span>Create Quiz</span>
            </button>
          </div>
        </div>
      </div>

      {/* Main Content */}
      <div className="flex-1 md:p-6">
        <div className="bg-white dark:bg-gray-950 rounded-lg shadow-sm border border-gray-200 dark:border-gray-800 overflow-hidden">
          {/* Filter Section */}
          <div className="p-5 border-b border-gray-200 dark:border-gray-800 bg-gray-50 dark:bg-gray-900">
            <div className="flex items-center mb-4">
              <Filter
                size={18}
                className="text-gray-500 dark:text-gray-400 mr-2"
              />
              <h2 className="text-lg font-medium text-gray-800 dark:text-gray-200">
                Filters
              </h2>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              <div className="bg-white dark:bg-gray-950 p-4 rounded-md border border-gray-200 dark:border-gray-800">
                <CourseList courseId={courseId} setCourseId={setCourseId} />
              </div>

              <div
                className={`bg-white dark:bg-gray-950 p-4 rounded-md border border-gray-200 dark:border-gray-800 transition-opacity duration-200 ${
                  !courseId ? "opacity-50" : ""
                }`}
              >
                <QuotaList
                  coursesId={courseId}
                  quotaId={quotaId}
                  setQuotaId={setQuotaId}
                  setQuotas={setQuotas}
                />
              </div>
            </div>
          </div>

          {/* Quiz List */}
          <div className="p-5">
            <div className="min-h-[400px]">
              <QuizList
                quotaId={quotaId}
                onEditQuiz={handleOpenUpdateModal}
                isRefreshing={isRefreshing}
                refreshFlag={refreshFlag}
                setRefreshFlag={setRefreshFlag}
              />
            </div>
          </div>
        </div>
      </div>

      {/* Modals */}
      {showModal && (
        <CreateQuizModal
          isOpen={showModal}
          onClose={handleCloseModal}
          onQuizCreated={handleQuizCreated}
          courseId={courseId}
          quotas={quotas}
          setQuotas={setQuotas}
          setRefreshFlag={setRefreshFlag}
        />
      )}
    </div>
  );
};

export default QuizManagement;
